export enum InputModeModel {
    Manual = 0,
    QrCode = 1,
    NfcTag = 2,
}
